import { useEffect } from "react";
import { HeaderUI } from "./HeaderUI";
import { StandardProps } from "../componentMap";
import { MOBILE_HEADER_PEEP_UPDATED } from "@/constants/constants";

export const Header = ({
  runtimeConfig,
}: Pick<StandardProps, "runtimeConfig">) => {
  const { esiBasepath } = runtimeConfig;
  const srcUrl = `${esiBasepath}/scaffold/header.html?includeCoreCSS=false&includeCoreJS=false&includePolyfills=false&isWide=true`;

  useEffect(() => {
    const handleMobileHeaderPeep = (
      e: Event & { detail?: { peeped?: boolean } },
    ) => {
      document.documentElement.style.scrollPaddingTop =
        e.detail?.peeped === true ? "var(--jl-header-height)" : "0";
    };

    window.addEventListener(MOBILE_HEADER_PEEP_UPDATED, handleMobileHeaderPeep);

    return () => {
      window.removeEventListener(
        MOBILE_HEADER_PEEP_UPDATED,
        handleMobileHeaderPeep,
      );
    };
  }, []);

  return <HeaderUI srcUrl={srcUrl} />;
};
